module.exports = __webpack_public_path__ + "static/media/kilrock.50297a0e.png";